import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
// import { getLastPath } from "../helpers";

const getLastPath = (pathsValidos) => {
  let lastPath = localStorage.getItem("lastPath") || "/";
  const isValid = pathsValidos?.some((obj) => obj.path === lastPath);
  if (!isValid) lastPath = pathsValidos[0]?.path;
  return lastPath;
};

export const PublicRoute = ({ children }) => {
  const { activeUsuario, paths } = useSelector((state) => state.auth);

  if (activeUsuario) {
    const path = getLastPath(paths?.routers);
    return <Navigate to={path} replace />;
  }

  return children;
};
